import { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import axios from "axios"
import { Button, Col, Input, Modal, Pagination, Select, Space, Spin, Table } from "antd";
import { DeleteFilled, PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import ControlBox from "./ControlBox";
import InsertWordModal from "./InsertWordModal";
import EditWordModal from "./EditWordModal"
import phoneticFuntions from "../../SentenceManage/controller/phoneticFuntions";
import PhoneticInput from "./PhoneticInput";
import FileCreater from "./FileCreater";

const backend = process.env.REACT_APP_BACKEND;
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
  .ant-table {
    display: flex;
    flex-direction: column;
  }
  .ant-table > .ant-table-container {
    /*flex-grow: 1;*/
    max-height: 92%;
  }

  
  .custom-footer {
    background-color: #fff; /* 적절한 배경색 지정 */
    padding: 10px; /* 원하는 패딩값 설정 */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ant-table-pagination.ant-pagination {
    display: none;
  }
  .ant-table-footer {
    width: 100%;
    padding: 0px;
  }
`


function WordTab ({baseParams, baseParamsHandler, pos}) {

  const [sourceData, setSourceData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSize: 100, // 한 페이지에 표시할 레코드 수
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSizeOptions: [5, 10, 50, 100, 200],
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
      showTotal: (total)=>`total ${total} items`,
      total:0
    },
    filters: {
    },
    sorter: {
    }
  });
  const [insertModal, setInsertModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [indexNumber, setIndexNumber] = useState(null)
  const [progressBar, setProgressBar] = useState([0,0])
  const stopRef = useRef(false)

  const tableParamsHandler = (pagination, filter, sorter) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current:1
      },
      sorter
    })
  }
  const paginationHandler = (current,pageSize) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: pageSize === tableParams.pagination.pageSize ? current : 1,
        pageSize: pageSize,
      }
    })
  }

  const dataChangeHandler = (record, indexNumber) => {
    const instance = sourceData.slice()
    instance.splice(indexNumber, 1, record)
    setSourceData(instance)
  }

  const dataChangeHandlerForAll = (record, column) => {
    // state의 변경 전에 임의로 바꾸는 것은 꼼수
    sourceData[record.indexNumber][column] = record[column]
    const instance = sourceData.slice()
    instance.splice(record.indexNumber, 1, record)
    setSourceData(instance)
  }

  const columns = [
    {
      title: "영어단어",
      dataIndex: "word",
      key: "word",
      width: "150px",
      sorter: (a,b)=>a.word-b.word
    },
    {
      title: "품사",
      dataIndex: "pos_name",
      key: "pos_name",
      width: "130px",
    },
    {
      title: "CEFR레벨(EVP)",
      dataIndex: "cefr_evp",
      key: "cefr_evp",
      width: "140px"
    },
    {
      title: "CEFR레벨(GPT)",
      dataIndex: "cefr_gpt",
      key: "cefr_gpt",
      width: "140px",
      render: (_) => <div style={{color: _ === "N/A" ? "red" : null}}>{_}</div>
    },
    {
      title: "단어장 수",
      dataIndex: "count",
      key: "count",
      width: "100px",
      render: (_)=><div style={{color: _ === 0 ? "red" : null}}>{_}</div> 
    },
    {
      title: "발음기호",
      dataIndex: "diacritic",
      key: "diacritic",
      width: "220px",
      render: (_,record)=><PhoneticInput record={record} dataChangeHandler={dataChangeHandler}/>
    },
    {
      title: "음성파일(1.0배속)",
      dataIndex: "word_voice_filename",
      key: "word_voice_filename",
      width: "400px",
      render: (_,record) => <FileCreater record={record} dataChangeHandler={dataChangeHandler} />
    },
    {
      title: "파생어",
      dataIndex: "derivative",
      key: "derivative",
      width: "200px"
    },
    {
      title: "처리",
      dataIndex: "indexNumber",
      key: "indexNumber",
      width: "110px",
      render: (_,record) =>
      <div>
        <a style={{margin:"0px 5px"}} onClick={()=>{openEditModal(_)}}>수정</a>
        <a style={{margin:"0px 5px"}} onClick={()=>{deleteHandler(record.id)}}>삭제</a>
      </div>
    },
    {}
  ]

  const getSourceData = () => {
    setLoading(true)
    const { current, pageSize } = tableParams.pagination;
    const sorterCol = tableParams.sorter.column?.dataIndex || "id"
    const sorterDirection = tableParams.sorter.order === "ascend" ? "ASC" : "DESC"

    axios
      .get(`${backend}/contents/new_word/word/list`,
      {params:{
        ...baseParams,
        current: current,
        pageSize: pageSize,
        sorterCol: sorterCol,
        sorterDirection: sorterDirection
      }})
      .then(res=>{
        const newSourceData = res.data.data[0].map((el,idx)=>{
          el.indexNumber = idx
          return el
        })

        setSourceData(newSourceData)
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: res.data.data[1][0]["FOUND_ROWS()"]
          }
        })
        setSelectedKeys([])
        setSelectedRows([])
      })
      .catch(err=>{
        console.log(err)
      })
      .finally(()=>{
        setLoading(false)
      })
  }

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    type: "checkbox",
    onChange: (keys, rows) => {
      setSelectedRows(rows.sort((a, b) => a.num - b.num));
      setSelectedKeys(keys.sort((a, b) => a - b));
    },
    getCheckboxProps: (record) => ({
      // disabled: record.hideCheckbox, // 특정 조건일 경우 사용하지 못하도록 함
      // className: record.hideCheckbox ? "hidden-checkbox" : "" // 클래스 설정 가능

    })
  }

  // 각 행별 이벤트를 모아놓은 객체를 리턴한다. 필요한 경우에만 사용하도록.
  // const onRowHandler = (record, rowIdx) => {
  //   return {
  //     onClick : () => {
  //       console.log(record)
  //       console.log(rowIdx)
  //     }
  //   }
  // }

  // 수정 버튼을 눌렀을 때의 함수
  const openEditModal = (_) => {
    setIndexNumber(_)
    setEditModal(true)
  }

  //삭제 버튼을 눌렀을 때의 함수
  const deleteHandler = (id) => {
    axios.delete(`${backend}/contents/new_word/word/list/${id}`)
      .then(res=>{
        getSourceData()
        Modal.success({
          title: "삭제 완료",
          content: "정상적으로 삭제 되었습니다.",
          okText: "확인",
        })
      })
      .catch(err=>{
        console.log(err)
      })
  }

  const deleteSelectedRow = () => {

    axios.delete(`${backend}/contents/new_word/word/list/${selectedKeys}`)
    .then(res=>{
      getSourceData()
      Modal.success({
        title: "삭제 완료",
        content: "정상적으로 삭제 되었습니다.",
        okText: "확인",
      })
    })
    .catch(err=>{
      console.log(err)
    })
  }

  const modalHandler = (modal, yn) => {
    if(modal === 'insertModal') {
      setInsertModal(yn)
      return
    }
    if(modal === 'editModal') {
      setEditModal(yn)
      return
    }
    if(modal === 'tableParams') {
      setTableParams(yn)
      return
    }
    if(modal === "spin") {
      setLoading(yn)
      return
    }
    if(modal === "progress") {
      setProgressBar(yn)
      return
    }
  }

  const stopRefHandler = () => stopRef.current = false

  useEffect(()=>{
    getSourceData()
  },[JSON.stringify(baseParams), tableParams.pagination.pageSize, tableParams.pagination.current, tableParams.sorter])

  return (
    <div style={{display: "flex", flexDirection:"column", height:"100%"}}>
      <Spin className="mySpin" spinning={loading} tip={
        progressBar[1] ?
         <>
         <div>{`${progressBar[0]} 개 단어 중..${progressBar[1]}개 진행중...`}</div>
         <Button onClick={()=>{stopRef.current=true}}>중지</Button>
         </> : null
      }>

        <InsertWordModal insertModal={insertModal} modalHandler={modalHandler} pos={pos} getSourceData={getSourceData}/>
        <EditWordModal 
          editModal={editModal} 
          modalHandler={modalHandler} 
          pos={pos} 
          sourceData={sourceData}
          getSourceData={getSourceData}
          indexNumber={indexNumber}
          setIndexNumber={setIndexNumber}
          tableParams={tableParams}
          setTableParams={tableParams}
        />

        <div style={{display:"flex", justifyContent:"space-between", marginBottom:"10px"}}>
          <span style={{ minWidth: "100px", textAlign: "left" }}>단어 목록</span>
          <ControlBox 
            baseParams={baseParams} 
            baseParamsHandler={baseParamsHandler} 
            pos={pos} modalHandler={modalHandler} 
            selectedRows={selectedRows}
            dataChangeHandlerForAll={dataChangeHandlerForAll}
            stopRef = {stopRef}
            stopRefHandler={stopRefHandler}
            tableParams={tableParams}
            paginationHandler={paginationHandler}
          />
        </div>

        <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
          <StyledTable
            className="pageTable"
            // onRow={onRowHandler}
            rowSelection={rowSelection}
            rowClassName={(record, index) => {
              return index === indexNumber ? "selectedRow" : "";
            }}
            columns={columns}
            dataSource={sourceData}
            rowKey="id"
            onChange={tableParamsHandler}
            pagination={tableParams.pagination}
            scroll = {{ x:"max-content", y:"max-content"}}
            footer={()=>
              <div className="custom-footer">
                <Button onClick={deleteSelectedRow}  disabled={!selectedRows.length}>
                  <DeleteFilled/>선택단어 삭제
                </Button>
                {
                  tableParams.pagination.pageSize
                  ? <Pagination {...tableParams.pagination} onChange={paginationHandler}/>
                  : null
                }
              </div>}
          ></StyledTable>
        </div>
      </Spin>
    </div>
  )
}

export default WordTab